import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ItemResolverStoreEffects } from './item-resolver-store.effects';
import { itemResolverStoreReducer } from './item-resolver-store.reducer';
import { ItemResolverStoreService } from './item-resolver-store.service';
import {
  STATE_FEATURE_ITEM_RESOLVER_STORE,
  getInitialItemResolverStoreState,
} from './item-resolver-store.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ItemResolverStoreEffects]),
    StoreModule.forFeature(
      STATE_FEATURE_ITEM_RESOLVER_STORE,
      itemResolverStoreReducer,
      { initialState: getInitialItemResolverStoreState },
    ),
  ],
  providers: [ItemResolverStoreService],
})
export class ItemResolverStoreModule {}
